import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { SHARED_CONSTANTS_AGENTIC_VALIDATION_ERROR_CODES } from "@lib/shared_constants.json";

export type PostAlloysProviderAgenticInvalidApiKeyPrefixError = FetchUserEncodedError<
  SHARED_CONSTANTS_AGENTIC_VALIDATION_ERROR_CODES["INVALID_API_KEY_PREFIX"]
>;
export type PostAlloysProviderAgenticApiKeyValidationFailedError = FetchUserEncodedError<
  SHARED_CONSTANTS_AGENTIC_VALIDATION_ERROR_CODES["API_KEY_VALIDATION_FAILED"]
>;

export type PostAlloysProviderAgenticErrors =
  | PostAlloysProviderAgenticInvalidApiKeyPrefixError
  | PostAlloysProviderAgenticApiKeyValidationFailedError;

export const isPostAlloysProviderAgenticError = (
  error: FetchRequestError
): error is PostAlloysProviderAgenticErrors => {
  return error instanceof FetchUserEncodedError;
};

export interface AlloysAgenticIntegration {
  company_id: string;
  app_group_id: string;
  integration_id: string;
  api_key: string | null;
  connected_at: string | null;
}

export interface GeminiAgenticIntegration extends AlloysAgenticIntegration {
  use_vertex_ai: boolean;
  vertex_project_id: string | null;
  use_oauth?: boolean;
  google_account_email?: string | null;
  oauth_connected_at?: string | null;
  oauth_project_id?: string | null;
  oauth_project_name?: string | null;
  oauth_connected?: boolean;
  oauth_pending?: boolean;
}

export interface DatabricksMosaicAgenticIntegration extends AlloysAgenticIntegration {
  workspace_name: string;
}

export interface GetAlloysProviderAgenticAppGroupIdResult {
  integration: AlloysAgenticIntegration | GeminiAgenticIntegration | DatabricksMosaicAgenticIntegration;
}

export type DeleteAlloysProviderAgenticAppGroupIdResult = Record<string, never>;

export interface DeleteAlloysProviderAgenticAppGroupIdProps {
  provider: string;
  appGroupId: string;
}

export interface PostAlloysProviderAgenticAppGroupIdResult {
  integration: AlloysAgenticIntegration | GeminiAgenticIntegration | DatabricksMosaicAgenticIntegration;
}

export interface PostAlloysProviderAgenticAppGroupIdProps {
  provider: string;
  appGroupId: string;
  apiKey: string;
  useVertexAi?: boolean;
  vertexProjectId?: string;
  workspaceName?: string;
}
